import { render, staticRenderFns } from "./PercentagePopulation.vue?vue&type=template&id=2fee1446&scoped=true&"
import script from "./PercentagePopulation.vue?vue&type=script&lang=ts&"
export * from "./PercentagePopulation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee1446",
  null
  
)

export default component.exports